import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 190.16 129.6"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"m144.27 86.99 45.9 42.61H53.07l91.19-42.61Z\" style=\"fill:#003089;\"></path><path d=\"M16.62 40.59 0 0h50.58L94.3 40.59H16.62Z\" style=\"fill:#ff1b2c;\"></path><path d=\"m16.62 40.59 86.67 8.35 33.03 30.66-84.89 45.96-34.81-84.97Z\" style=\"fill:#008c31;stroke:transparent;stroke-width:3.02px;\"></path><path d=\"m111.19 69.29-59.77 56.28-34.8-84.98 94.57 28.7Z\" style=\"stroke:transparent;stroke-width:3.02px;fill:#ffb200;\"></path><path d=\"m73.09 79.94-21.67 45.63-34.8-84.98 56.47 39.34Z\" style=\"stroke:transparent;stroke-width:3.02px;\"></path><circle cx=\"34.46\" cy=\"22.72\" r=\"10.82\" style=\"fill:#ffb100;isolation:isolate;opacity:.97;\"></circle>", 6)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "SA-logo"}) } }